import { ReactNode } from 'react';
import { observer } from 'mobx-react-lite';

import { useApiClient } from 'app/common/api/api-client.provider';
import { TConstraints } from 'app/common/constraints/core/constraints';
import { useNotifyFactory } from 'app/common/notifications/features/notifications';
import { HttpRequest } from 'app/libs/http-client/types';
import { useInstance } from 'app/libs/use-instance';
import { TRoleNames } from 'app/railways/domains/access/features/roles/roles';

import {
  TEntityGridColumn,
  TEntityGridConstraints,
  TEntityGridExtraFilter,
  TEntityGridRowModels,
} from '../../core';
import { EntityGridNotificationsProvider } from '../entity-grid-notifications';
import { EntityGridConfig } from './entity-grid-config';
import { EntityGridConfigProvider } from './entity-grid-config.provider';

type EntityGridProps = TEntityGridRowModels & {
  recordsLimit: number;
  request: (constraints?: TConstraints<any, any>) => HttpRequest;
  columns: TEntityGridColumn[];
  userRoles: TRoleNames[];
  children: ReactNode;
  initialState?: TEntityGridConstraints;
  extraFilters?: TEntityGridExtraFilter[];
};

export const EntityGridRoot = observer(
  ({
    rowModelType,
    recordsLimit,
    initialState,
    columns,
    userRoles,
    request,
    extraFilters,
    children,
  }: EntityGridProps) => {
    const notify = useNotifyFactory();
    const apiClient = useApiClient();
    const gridConfig = useInstance(
      () =>
        new EntityGridConfig({
          rowModelType,
          apiClient,
          recordsLimit,
          columns,
          extraFilters,
          initialState,
          userRoles,
          notify,
          request,
        }),
    );

    // useEffect(() => {
    //   gridConfig.resource.read();

    //   return () => gridConfig.dispose();
    // }, [gridConfig]);

    return (
      <EntityGridNotificationsProvider value={notify}>
        <EntityGridConfigProvider value={gridConfig}>
          {children}
        </EntityGridConfigProvider>
      </EntityGridNotificationsProvider>
    );
  },
);
